module.exports = __webpack_public_path__ + "img/workshops_2.1.ddecd8f6.jpeg";